import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';

// Initialize VueSocialSharing and set custom sharing networks if specified
Vue.use(VueSocialSharing, [{"networks":{"linkedin":"https:\u002F\u002Fwww.linkedin.com\u002Fsharing\u002Fshare-offsite\u002F?url=@u"}}][0]);
